<template>
  <div>
    <input type="hidden" v-bind="$props" :value="JSON.stringify(currentValue)">
    <TransactionSearchControl :value="currentValue" @input="currentValue = $event"/>
  </div>
</template>

<script lang="ts">
import TransactionSearchControl from '@/components/cadastre/TransactionSearchControl.vue';
import {SearchResultItem} from '@/model/api/search';
import {defineComponent, ref} from 'vue';

export default defineComponent({
    components: {TransactionSearchControl},
    props: {
        'data-nette-rules': {
            type: String,
        },
        'name': {
            type: String,
        },
        'value': {
            type: String,
        },
    },
    setup(props) {
        const currentValue = ref<SearchResultItem | null>(
            props.value !== undefined ? JSON.parse(props.value) : null,
        );

        return {currentValue};
    },
});
</script>
